<div class="bankFooterBlock d-flex justify-content-between align-content-center align-items-center" >
    <div>
        Powered by Creditas Solutions Pvt. Ltd.
    </div>
    <div class="d-flex align-items-center">
        <div class="mx-2">
            <img src="assets/images/logo/pciDss.svg" alt="pciDssLogo">
        </div>
        <!-- <div>
            <img src="assets/images/logo/creditasSolutionSmall.png"  alt="creditasLogo">
        </div> -->
    </div>
</div>